import React from 'react';

import styles from './LoadingErrorMessage.module.scss';

const LoadingErrorMessage = () => (
  <div className={styles['loading-error-message']}>
    <p className={styles['loading-error-message-header']}>
      We&apos;re having trouble loading messages.
    </p>
    <p className={styles['loading-error-message-subheader']}>
      Please try again later.
    </p>
  </div>
);

export default LoadingErrorMessage;
